import { ReactElement, ReactNode } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

interface IIconTooltipProps {
  overlay: ReactNode;
  placement?: Placement;
  dataTestId?: string;
  children: ReactElement;
}

const IconTooltip = ({ overlay, placement = 'auto', dataTestId, children }: IIconTooltipProps) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip
        id="tooltip-icon-overlay"
        data-test={dataTestId ? `${dataTestId}-tooltip` : undefined}
      >
        {overlay}
      </Tooltip>
    }
  >
    {children}
  </OverlayTrigger>
);

export default IconTooltip;
